import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { ViewType } from './view-type';
import { PURGE } from 'redux-persist';

export interface ViewSelection {
  componentId: string;
  selection: ViewType;
}

const initialState = {
  selections: [
    {
      componentId: 'forms-component',
      selection: ViewType.Simple
    }
  ] as ViewSelection[]
};

const dataViewSelectionSlice = createSlice({
  name: 'dataViewSelection',
  initialState,
  reducers: {
    toggleSelection: (
      state,
      {
        payload: { newSelection, componentId }
      }: PayloadAction<{ newSelection: ViewType; componentId: string }>
    ) => {
      const selectionToToggle = state.selections.find(
        (selection) => selection.componentId === componentId
      );

      if (selectionToToggle) {
        selectionToToggle.selection = newSelection;
      } else {
        state.selections.push({ componentId, selection: newSelection });
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

export const selectViewSelectionByComponentId = createSelector(
  (state: RootState) => state.dataViewSelections,
  (state: RootState, componentId: string) => componentId,
  (state, componentId) => {
    const viewSelection: ViewSelection | undefined = state.selections.find(
      (options) => options.componentId === componentId
    );

    return { selection: viewSelection?.selection ?? ViewType.Simple };
  }
);

export const { toggleSelection } = dataViewSelectionSlice.actions;

export default dataViewSelectionSlice.reducer;
